import { cn } from "../../../../utils/cn.ts";
import { FontStyles } from "../../../../utils/font-styles.ts";
import {
  focusStylesUnderlineTab,
  focusStylesUnderlineTabActive,
  underlineTabActive,
} from "../../../../utils/focus-styles.ts";

import { ComponentProps, forwardRef } from "react";

interface GalleryModalUnderlineTabsTriggerProps extends ComponentProps<"button"> {
  icon: string;
  label: string;
  className?: string;
  isActive: boolean;
}

export const GalleryModalUnderlineTabsTrigger = forwardRef<HTMLButtonElement, GalleryModalUnderlineTabsTriggerProps>(
  ({ icon, label, className, isActive, ...rest }, ref) => (
    <button
      ref={ref}
      className={cn(
        "group flex items-center justify-center gap-2 cursor-pointer",
        "px-1.5 py-4.5",
        "shadow-[inset_0_-4px_0_0_transparent]",
        "hover:bg-loch-50",
        "active:bg-loch-100",
        !isActive && focusStylesUnderlineTab,
        isActive && underlineTabActive,
        isActive && focusStylesUnderlineTabActive,
        className,
      )}
      {...rest}
    >
      <i
        className={cn(
          `fa-${icon} fa-sharp fa-regular`,
          FontStyles["body-md"],
          "text-loch",
          "group-data-[state=active]:text-loch",
          "leading-none",
        )}
        aria-hidden="true"
      />
      <span className={cn("hidden md:inline font-medium", FontStyles["body-l"], "text-slate", "!leading-none")}>
        {label}
      </span>
    </button>
  ),
);
